import { Outlet } from "react-router-dom"

const PersonPage = () => {
    return <Outlet />
}

export default PersonPage;
